// src/components/RequireAuth.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../useAuth';
import { CommandPaletteProvider } from '../CommandPalette/CommandPaletteContext';
import CommandPalette from '../CommandPalette/CommandPalette';

export default function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div className="fixed inset-0 bg-black" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/Login" state={{ from: location }} replace />;
  }

  // El palette se monta aquí y no en AppShell a propósito: AppShell solo cubre
  // /, /home y /dashboard, y ⌘K tiene que funcionar también donde no hay rail
  // — sobre todo en el editor de workflows, que es donde uno se pierde más.
  return (
    <CommandPaletteProvider>
      <Outlet />
      <CommandPalette />
    </CommandPaletteProvider>
  );
}
